<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 22C8.8863 22 6.105 20.5771 4.271 18.346M12 22C15.114 22 17.896 20.5775 19.73 18.346M4.271 18.346C4.271 18.346 6.5 15.5 12 15.5M4.271 18.346C4.28403 18.3294 6.51611 15.5 12 15.5M12 15.5C17.5 15.5 19.73 18.346 19.73 18.346M12 15.5C17.4503 15.5 19.69 18.2955 19.73 18.346M12 12C12.7956 12 13.5587 11.6839 14.1213 11.1213C14.6839 10.5587 15 9.79565 15 9C15 8.20435 14.6839 7.44129 14.1213 6.87868C13.5587 6.31607 12.7956 6 12 6C11.2044 6 10.4413 6.31607 9.87868 6.87868C9.31607 7.44129 9 8.20435 9 9C9 9.79565 9.31607 10.5587 9.87868 11.1213C10.4413 11.6839 11.2044 12 12 12Z"
      stroke="var(--svg-col, #0D0802)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
